// The cart is cleared once a registration is paid, but the confirmation page
// still needs it for subsidy text and fees, and Stripe's redirect reloads the
// page. Keep a copy for this browser tab, keyed by payment intent.
const STORAGE_KEY = 'lastCheckoutSummary';

export interface CheckoutSummary {
  paymentIntentId: string;
  selections: any[];
}

export const saveCheckoutSummary = (
  paymentIntentId: string,
  selections: any[]
) => {
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ paymentIntentId, selections })
    );
  } catch {
    // Storage can be unavailable (private mode); the summary is optional.
  }
};

export const getCheckoutSummary = (
  paymentIntentId: string
): CheckoutSummary | null => {
  try {
    const summary = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
    return summary?.paymentIntentId === paymentIntentId &&
      Array.isArray(summary.selections)
      ? summary
      : null;
  } catch {
    return null;
  }
};
